export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEER0ItSGEUISIAhD8AAIQ+BgCEVgABvBgAAIRXBA2ERj4AvBqDIgCEQgYBhEQCAIQ9AQC8GwsBhEABALwcAQCEQxsAvB0BALweAQCEWBsAhFQBAIRVAAC8Hw==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/GB-V.bcmap
// module id = 638
// module chunks = 502